export default __webpack_public_path__ + "static/life-3-e652f95b7d8ac6bfd79ddeaaae7d6a09.png";